import { styled } from "styled-components";

import { PanelBackgroundFlex } from "~src/component/Styled";

export const PersonalizationPanelContainer = styled(PanelBackgroundFlex)`
  padding-bottom: 16px;
`;
